module.exports = "/_next/static/images/pw-f34a17aa432b5d6b690fe92a5dfd5cb7.svg";